// ----------------------------------------------------------------------
// (c) Copyright 2020, Dark Star Systems, Inc.  All rights reserved.
// This file may contain proprietary and confidential information.
// DO NOT COPY or distribute in any form without prior written consent.
// ----------------------------------------------------------------------

import * as Three from 'three'

export const vignetteShader = {
  uniforms: {
    "tDiffuse": {type: "t", value: null},
    "radius": {type: "f", value: 0.5},         // in screen-half-widths
    "scaleWidth": {type: "f", value: 1.7777}, // default: 16x9 aspect ratio
    "edgeWidth": {type: "f", value: 0.3},
    "darkness": {type: "f", value: 0.5},
    // viewport size; used for aspect ratio
    "width": {type: "f", value: 16},
    "height": {type: "f", value: 9}
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
     vUv = uv;
     gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }`,
  fragmentShader: `
uniform float radius;
uniform float scaleWidth;
uniform float edgeWidth;
uniform float darkness;
uniform float width;
uniform float height;

uniform sampler2D tDiffuse;

varying vec2 vUv;

void main() {
  vec4 color = texture2D( tDiffuse, vUv );
  // use the *height* as the canonical unit
  // (this is unusual but for our front end the height is fixed and is the
  // height of the rendered output, but the width scales with monitor size)
  vec2 aspect = vec2(width / height, 1.0);  // for 16x9 image this will be [1.777, 1]
  // put in +/- 1 square space, centered at origin
  vec2 vignetteCoords = (vUv * 2.0 - vec2(1.0)) * aspect;
  vignetteCoords.x /= max(0.001, scaleWidth);
  float dist = length(vignetteCoords);
  float halfWidth = edgeWidth * 0.5;
  // 0 inside, 1 outside
  float vignette = smoothstep(max(0.0, radius - halfWidth), radius + halfWidth, dist);
  // 1 inside, 1-darkness outside
  float mask = 1.0 - (vignette * darkness);
  color.rgb *= mask;
  gl_FragColor = color;
}`
}

export const vignetteMaterial = new Three.ShaderMaterial(vignetteShader)
